import { I18N } from '../actions/i18n';
import { USER } from '../actions/user';

const defaultState = {
  locales: [{ id: "en", name: "English", image: "https://flagcdn.com/us.svg" }],
  locale: "en",
  translations: {},
};

const storageLocale = localStorage.getItem('locale');
// if (storageLocale && defaultState.locales.find(({ id }) => id === storageLocale)) {
  defaultState.locale = storageLocale;
// }

export default (state = defaultState, { type, ...action }) => {
  switch (type) {
    case I18N.CHANGE_LOCALE_DONE:
      localStorage.setItem("locale", action.locale);
      return { ...state, locale: action.locale };

    case USER.LOGIN_DONE:
      localStorage.setItem("locale", action.user.lang);
      return { ...state, locale: action.user.lang };

    case I18N.LOAD_DONE:
      return { ...state, translations: action.translations };

    case I18N.LOAD_LOCALES_DONE:
      return { ...state, locales: action.languages };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/i18n.js